module.exports = __webpack_public_path__ + "static/media/driver-2.6ca55eaa.jpg";